export function changeYear(json) {
    for (let i in json.data)
    {
        if (json.data[i].rpT_CREATE_DATE !== '' && json.data[i].rpT_CREATE_DATE !== null) {
            let date = json.data[i].rpT_CREATE_DATE.split(' ')[0];
            let years = parseInt(date.split('/')[2])
            if (years > 2500) {
                years = years - 543;
            }
            let time = json.data[i].rpT_CREATE_DATE.split(' ')[1]
            json.data[i].rpT_CREATE_DATE =
                date.split('/')[0] +
                '/' +
                date.split('/')[1] +
                '/' +
                years +
                ' ' +
                time
        }

        if (json.data[i].rpT_RANGE_DATE !== '' && json.data[i].rpT_RANGE_DATE !== null) {
            let rangedate = json.data[i].rpT_RANGE_DATE.split(' - ')[0];
            let rangeyears = parseInt(rangedate.split('/')[2])
            if (rangeyears > 2500) {
                rangeyears = rangeyears - 543;
            }
            let rangedate2 = json.data[i].rpT_RANGE_DATE.split(' - ')[1];
            let rangeyears2 = parseInt(rangedate2.split('/')[2])
            if (rangeyears2 > 2500) {
                rangeyears2 = rangeyears2 - 543;
            }
            json.data[i].rpT_RANGE_DATE =
                rangedate.split('/')[0] +
                '/' +
                rangedate.split('/')[1] +
                '/' +
                rangeyears +
                ' - ' +
                rangedate2.split('/')[0] +
                '/' +
                rangedate2.split('/')[1] +
                '/' +
                rangeyears2
        }
    }

    return json
}


// WEBPACK FOOTER //
// ./src/views/Tools/ChanheYaer.js